import React from "react";
import { Link } from "react-router-dom";
import { CATEGORIES } from "../constants";

const Footer = () => (
  <footer className="footer">
    <div className="container">
      <div className="footer__grid">
        <div>
          <Link to="/" className="brand">
            <span className="brand__mark">B</span>
            BrainBytes
          </Link>
          <p>
            A knowledge base for engineers — write it down, share it, and let AI
            turn it into notes and drills.
          </p>
        </div>

        <div>
          <h4 className="eyebrow">Topics</h4>
          <ul>
            {CATEGORIES.map((c) => (
              <li key={c}>
                <Link to={`/posts/categories/${c}`}>{c}</Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="eyebrow">Explore</h4>
          <ul>
            <li>
              <Link to="/">Latest posts</Link>
            </li>
            <li>
              <Link to="/authors">Authors</Link>
            </li>
            <li>
              <Link to="/ai">AI Note Generator</Link>
            </li>
            <li>
              <Link to="/fact">QuickLearn</Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer__bottom">
        <span>© {new Date().getFullYear()} BrainBytes</span>
        <span>
          Built by{" "}
          <a href="https://yashsachan.netlify.app/" target="_blank" rel="noopener noreferrer">
            Yash Sachan
          </a>
        </span>
      </div>
    </div>
  </footer>
);

export default Footer;
